export const constant = {
    path: process.env.REACT_APP_BASE_URL
}